var _path, _path2, _path3, _path4, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStampTimewatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 76C55.8823 76 72 59.8823 72 40C72 20.1178 55.8823 4 36 4C16.1178 4 0 20.1178 0 40C0 59.8823 16.1178 76 36 76Z",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 71C59.33 71 75 55.33 75 36C75 16.67 59.33 1 40 1C20.67 1 5 16.67 5 36C5 55.33 20.67 71 40 71Z",
    fill: "white",
    stroke: "#00193C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37.5C22 39.7981 22.4656 42.0738 23.3702 44.197C24.2748 46.3202 25.6006 48.2493 27.2721 49.8744C28.9435 51.4994 30.9278 52.7884 33.1117 53.6679C35.2956 54.5474 37.6362 55 40 55C42.3638 55 44.7044 54.5474 46.8883 53.6679C49.0722 52.7884 51.0565 51.4994 52.7279 49.8744C54.3994 48.2493 55.7252 46.3202 56.6298 44.197C57.5344 42.0738 58 39.7981 58 37.5C58 32.8587 56.1036 28.4075 52.7279 25.1256C49.3523 21.8437 44.7739 20 40 20C35.2261 20 30.6477 21.8437 27.2721 25.1256C23.8964 28.4075 22 32.8587 22 37.5Z",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 28V38L46 44",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 15,
    x2: 46,
    y2: 15,
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 23.5858,
    x2: 53.5858,
    y2: 22,
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 19,
    x2: 40,
    y2: 16,
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStampTimewatch);
export default __webpack_public_path__ + "static/media/ic-stamp-timewatch.4735797516b6a604553006090455b6ac.svg";
export { ForwardRef as ReactComponent };